import { FBmsgIcon } from '../messengers/FBmsgIcon';
import { IColorIcon } from './WatsupIcon';

export const FBFilterIcon = () => {
    return <FBmsgIcon />;
};
